import React from 'react'
import tw from 'tailwind-styled-components'
import {LangType} from 'yougile-lang'
import {Help} from '@components/common/help/help'

const WrapperTw = tw.div`
  rounded-8
  bg-grey-l100
  shadow-border-1
  shadow-grey-l60
`

const HeaderTw = tw.div<{$headerPaddings?: string}>`
  flex
  justify-between
  items-center
  whitespace-nowrap

  ${p => (p.$headerPaddings ? p.$headerPaddings : 'p-16')}
`

const ChildrenTw = tw.div`
  p-16
`

const FooterTw = tw.div`
  p-16
  flex
  gap-16
  items-center
`

const TitleTw = tw.div`
  flex
  items-center
  text-primary
  text-18
  font-semibold
  leading-6
`

interface Props {
  children: React.ReactNode
  header?: React.ReactNode
  footer?: React.ReactNode
  title: React.ReactElement | string
  titlePrefix?: React.ReactNode
  help?: keyof LangType['help']
  className?: string
  headerPaddings?: string
}

export const Panel = ({
  children,
  header,
  footer,
  title,
  titlePrefix,
  help,
  className,
  headerPaddings
}: Props) => {
  return (
    <WrapperTw className={className}>
      <HeaderTw $headerPaddings={headerPaddings}>
        <div className="flex h-24">
          <TitleTw>
            {title}
            {titlePrefix}
          </TitleTw>
          {help && (
            <div className="-mt-4 transform scale-75">
              <Help name={help} />
            </div>
          )}
        </div>
        {header && <div className="flex w-full h-24">{header}</div>}
      </HeaderTw>
      <ChildrenTw>{children}</ChildrenTw>
      {footer && <FooterTw>{footer}</FooterTw>}
    </WrapperTw>
  )
}
